import React from 'react';
import { CHECKOUT_URL } from '../constants';
import { ArrowRight } from 'lucide-react';
interface CtaButtonProps {
  text?: string;
  subtext?: string;
  className?: string;
}
export function CtaButton({
  text = '¡QUIERO MI ACCESO AHORA!',
  subtext = '🔒 Pago 100% seguro - 📥 Descarga inmediata',
  className = ''
}: CtaButtonProps) {
  return <div className={`flex flex-col items-center w-full max-w-2xl mx-auto ${className}`} data-id="element-1">
      <a href={CHECKOUT_URL} className="w-full group relative inline-flex items-center justify-center px-8 py-5 text-xl md:text-2xl font-black text-white transition-all duration-200 bg-green-600 border-b-8 border-green-800 rounded-xl hover:bg-green-500 hover:border-green-700 hover:-translate-y-1 active:border-b-0 active:translate-y-2 shadow-xl hover:shadow-2xl text-center" data-id="element-2">
        <span className="mr-3" data-id="element-3">{text}</span>
        <ArrowRight className="w-6 h-6 md:w-8 md:h-8 animate-pulse" data-id="element-4" />
      </a>
      {subtext && <p className="mt-3 text-sm md:text-base font-medium text-gray-600 flex items-center gap-2" data-id="element-5">
          {subtext}
        </p>}
    </div>;
}